import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BarcodeFormat } from '@zxing/library';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'app-scanner',
    templateUrl: './scanner.component.html',
    styleUrls: ['./scanner.component.scss'],
    standalone: false
})
export class ScannerComponent implements AfterViewInit {

  @Output() readResult = new EventEmitter<string>();

  @ViewChild('scanner', { static: false })
  scanner!: ZXingScannerComponent;

  allowedFormats = [ BarcodeFormat.QR_CODE, BarcodeFormat.EAN_13, BarcodeFormat.CODE_128, BarcodeFormat.DATA_MATRIX];

  devices: MediaDeviceInfo[] = [];

  permission!: boolean;

  torchCompatible: boolean = false; 

  constructor() { 
  }

  ngAfterViewInit(): void {
    this.scanner.askForPermission();
    this.scanner.delayBetweenScanSuccess = environment.SCANNER_READ_LOCK_SECONDS;
  }

  public onCamerasFound(devices: MediaDeviceInfo[]): void{
    this.devices = devices;
    this.devices.forEach((device) => console.log("Found devices: "+device.label + " | " + device.kind));
  }

  public changeCamera(device: MediaDeviceInfo | undefined): void {
    this.scanner.device = device;
  }

  public scanSuccessHandler(result: string): void {
      this.readResult.emit(result);
  }

  public toggleTorch(): void {
    this.scanner.torch = !this.scanner.torch;
  }

  public onTorchCompatible(value: boolean): void {
    this.torchCompatible = value;
    console.log("Torch compatible: " + value);
  }

}
